var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05658 1.91748H3.36431C2.83466 1.91748 2.40379 2.34912 2.41833 2.87856C2.72567 14.0691 8.47464 19.8181 19.6652 20.1254C20.1947 20.14 20.6263 19.7091 20.6263 19.1795V15.4872C20.6263 15.1082 20.4031 14.7648 20.0568 14.6109L16.8117 13.1686C16.5014 13.0307 16.1411 13.0671 15.8648 13.2645L13.3935 15.0298C13.1208 15.2245 12.764 15.2629 12.4576 15.1275C9.50119 13.8213 8.72246 13.0426 7.41624 10.0862C7.28082 9.77974 7.31922 9.42299 7.51399 9.15034L9.27923 6.679C9.47662 6.40263 9.51314 6.04246 9.37519 5.73211L7.93292 2.48699C7.779 2.14068 7.43556 1.91748 7.05658 1.91748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficePhone);
export default __webpack_public_path__ + "static/media/officePhone.12766eaabde9bfbdc11559c2bc4c4dd9.svg";
export { ForwardRef as ReactComponent };